import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FindRepForm from './FindRepForm';
import {
    AnimationContainer,
    Container as BaseContainer,
    Body as BaseBody
} from '../Shared/PopupModalStyles';

const Container = styled(BaseContainer)`
    width: 100;

    @media (max-width: 30em) {
        width: 100%;
    }
`;

const Body = styled(BaseBody)`
    padding: 25px 20px;
`;

const FindLocalRepPopup = props => (
    <AnimationContainer>
        <Container>
            <Body>
                <FindRepForm
                    isDoubleCheckRepPopup={props.isDoubleCheckRepPopup}
                    address={props.address}
                    submitting={props.submitting}
                    onBack={props.hideFindRepPopup}
                    handleSubmit={event => {
                        event.preventDefault();
                        props
                            .onSubmit(props.address)
                            .catch(() => console.log('Representatives not found!'));
                    }}
                />
            </Body>
        </Container>
    </AnimationContainer>
);

FindLocalRepPopup.propTypes = {
    address: PropTypes.string,
    hideFindRepPopup: PropTypes.func.isRequired,
    isDoubleCheckRepPopup: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired
};

export default FindLocalRepPopup;
